import React from "react";

export function ForbiddenStatusShower() {
    return (
        <div className={`bg-white rounded-lg shadow-lg mt-4 px-3 py-3`}>
            403 Forbidden: У вас нет прав для доступа к этому ресурсу
        </div>
    )
}